module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissable"
  }, [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n\t\t\t×\n\t\t")]), _vm._v(" "), _c('b', [_vm._v("Novidade!")]), _vm._v(" Agora você pode enviar a duplicata para seus clientes assinarem de forma digital. Qualquer dúvida, entre em contato com o suporte!\n\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-655c6c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 402
// module chunks = 1